import React from 'react';
import { FEATURE_CONFIG } from './constants';
import * as styles from './styles';

interface FeaturesListProps {
  features?: string[] | null;
}

const ICON_SIZE = 18;

/**
 * Component that renders a horizontal list of features (available services).
 *
 * @component
 * @param {FeaturesListProps} props
 * @returns {JSX.Element}
 */
const FeaturesList: React.FC<FeaturesListProps> = ({ features }) => {
  if (!Array.isArray(features)) {
    return (
      <span style={styles.noFeaturesText}>
        <strong>No contiene servicios</strong>
      </span>
    );
  }

  return (
    <div style={styles.container}>
      {features.map((key) => {
        const config = FEATURE_CONFIG[key];
        if (!config) return null;

        const iconWithSize = React.cloneElement(config.icon, { size: ICON_SIZE });

        return (
          <div key={key} style={styles.item}>
            {iconWithSize}
            <span>{config.label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default FeaturesList;
